export default __webpack_public_path__ + "a37518fbc1cd3ede576f87812a83d355.svg";